import constant from "../../../utils/constant";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { XIcon } from "@heroicons/react/outline";
const CannedTestCopy: React.FC<any> = ({
  closeModal,
  cannedTestId,
}: {
  closeModal: () => void;
  cannedTestId: number;
  currentSubjectId: number;
}) => {
  const [subjectId, setSubjectId] = useState<number>();
  const navigate = useNavigate();
  const closeModalHandler = () => {
    closeModal();
  };

  const submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const module = await import("react-toastify");
    const service = await import("../../../api/cannedTests.service");

    if (subjectId) {
      navigate(constant.CANNEDTEST, {
        state: {
          cannedTestId: cannedTestId,
          subjectId: subjectId,
        },
      });
    } else {
      module.toast.error("Please enter a Subject Id");
    }
  };

  return (
    <>
      <div>
        <div
          className="fixed z-10 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
            ></div>

            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>

            <div className="inline-block align-bottom bg-white px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 h-64">
              <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                <button
                  onClick={() => closeModalHandler()}
                  type="button"
                  className="bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-text-primary"
                >
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>

              <div className="sm:flex sm:items-start">
                <h3 className="text-gray-700">
                  Enter a Subject Id for the new Canned Test
                </h3>
              </div>
              <form action="#" onSubmit={submitHandler}>
                <div>
                  <div className="mt-5">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700">
                        Subject Id
                      </label>
                    </div>
                    <div
                      id="subjects"
                      className="mt-1 block focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                    >
                      <input
                        id="subjectId"
                        name="subjectId"
                        type="text"
                        autoComplete="off"
                        className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        value={subjectId || ""}
                        onChange={(e) => {
                          setSubjectId(Number(e.target.value));
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex justify-end">
                    <button
                      type="submit"
                      className="inline-flex items-center px-3 py-2 mt-5 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                    >
                      Copy
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CannedTestCopy;
